// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qfa6","colBig":"styles_colBig__3sZ11","colSmall":"styles_colSmall__stFJh"};